export default {
  viewBox: "0 0 16 16",
  html: "<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M8.354 10.854a.5.5 0 0 1-.708 0l-5-5a.5.5 0 1 1 .708-.708L8 9.793l4.646-4.647a.5.5 0 0 1 .708.708z\" clip-rule=\"evenodd\"/>"
};